import {datesHelper} from "../../_helpers";

const state = {
  idRefuge: 0,
  name: '',
  covidAlert: 0,
  idRoom: 0,
  roomName: '',
  checkIn: null,
  checkOut: null,
  humanCheckIn: '',
  humanCheckOut: '',
  nigths: 1,
  persons: 1,
  booking: '',
  bookingId: '',
  services: [],
  otherServices: []
}
const getters = {
  getRefuge: () => {
    return {
      id: state.idRefuge,
      name: state.name,
      covidAlert: state.covidAlert,
      idRoom: state.idRoom,
      roomName: state.roomName,
      checkIn: state.checkIn,
      checkOut: state.checkOut,
      humanCheckIn: state.humanCheckIn,
      humanCheckOut: state.humanCheckOut,
      nigths: state.nigths,
      persons: state.persons,
      booking: state.booking,
      bookingId: state.bookingId,
      services: state.services,
      otherServices: state.otherServices
    }
  }
}

const actions = {
  changeCheckIn({commit}, dateIn) {
    let humanize = datesHelper.momentToDate(dateIn, "DD/MM/YYYY");
    commit('setCheckIn', {dateIn, humanize});
    return true
  },
  changeCheckOut({commit, state}, dateOut) {
    let humanize = datesHelper.momentToDate(dateOut, "DD/MM/YYYY");
    let nigths = datesHelper.diffenceDays(state.checkIn, dateOut);
    commit('setCheckOut', {dateOut, humanize, nigths});
    return true
  }
}

const mutations = {
  clearRefugeData(state) {
    state.idRefuge = 0
    state.name = ''
    state.covidAlert = 0
    state.idRoom = 0
    state.roomName = ''
    state.checkIn = null
    state.checkOut = null
    state.humanCheckIn = ''
    state.humanCheckOut = ''
    state.nigths = 1
    state.persons = 1
    state.booking = ''
    state.bookingId = ''
    state.services = []
    state.otherServices = []

  },
  clearDates(state){
    state.checkIn = null
    state.checkOut = null
    state.nigths = 1
    state.humanCheckIn = ''
    state.humanCheckOut = ''
  },
  setCurrentRefuge(state, data) {
    state.idRefuge = data.id;
    state.name = data.name;
    state.covidAlert = parseInt(data.covidAlert)
  },
  setCurrentRoom(state, data) {
    state.idRoom = data.id
    state.roomName = data.roomName
  },
  setCurrentPersons(state, persons) {
    state.persons = persons
  },
  setCheckIn(state, data) {
    state.checkIn = data.dateIn;
    state.humanCheckIn = data.humanize;
  },
  setCheckOut(state, data) {
    state.checkOut = data.dateOut;
    state.humanCheckOut = data.humanize;
    state.nigths = data.nigths;
  },
  setBookingData(state, data) {
    state.bookingId = data.id
    state.booking = data.booking
    state.services = data.services
    state.otherServices = data.otherServices
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/_store/modules/refuge.js